import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import Backend from "i18next-http-backend";

i18n
  // i18next-http-backend
  // loads translations from your server
  // https://github.com/i18next/i18next-http-backend
  .use(Backend)
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    debug: true,
    fallbackLng: "en",
    supportedLngs: [
      "en",
      "fr",
      "es",
      "ar",
      "zh",
      "hi",
      "ru",
      "pt",
      "bn",
      "de",
      "ja",
      "ms",
      "ko",
      "it",
      "tr",
      "pl",
      "nl",
      "vi",
      "th",
      "sv",
      "fa",
      "ur",
      "he",
    ],
    nonExplicitSupportedLngs: true,
    backend: {
      loadPath: "/locales/{{lng}}/{{ns}}.json",
      queryStringParams: { v: "20260424h" },
    },
    detection: {
      order: ["localStorage", "path", "navigator"],
      lookupFromPathIndex: 1,
      caches: ["localStorage"],
    },
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
  });

export default i18n;
